import { Box } from "@mui/system";
import BuscaConfiguracao from "../buscaConfiguracao";
import Erp from "./erp";
import MacrosGlobais from "./macrosGlobais";
import ConfigBotWhatsApp from "./configBotWhatsApp";

// Índice da busca (ver ../buscaConfiguracao). Ao criar uma configuração nova
// na tela, inclua-a aqui com o mesmo id.
const SECOES = [
  {
    secao: "erp",
    titulo: "Integração com ERP",
    termos: "hubsoft ixc conexao banco api variaveis de ambiente",
    itens: [
      ["erp-adicionar", "Adicionar ERP", "novo cadastrar"],
      ["erp-lista", "ERPs cadastrados", "conexao dados de acesso banco api"],
    ],
  },
  {
    secao: "macros",
    titulo: "Macros Globais",
    termos: "variavel valor",
    itens: [
      ["macros-lista", "Macros configuradas", "variavel valor descricao"],
    ],
  },
  {
    secao: "bot-whatsapp",
    titulo: "Configurações do bot de WhatsApp",
    termos: "alertas instabilidade api banco mensagem",
    itens: [["bot-grupo", "ID do grupo de WhatsApp dos alertas", "grupo bot"]],
  },
];

export default function ConfigInterno() {
  return (
    <Box sx={{ p: 2 }}>
      <BuscaConfiguracao
        secoes={SECOES}
        placeholder="Buscar configuração (ex.: ERP, macro, WhatsApp)"
      />
      <Erp />
      <MacrosGlobais />
      <ConfigBotWhatsApp />
    </Box>
  );
}
